import PropTypes from "prop-types";
import React from "react";
import attestationMotoScan from "../../../../assets/img/scan_att.jpg";
import signature from "../../../../assets/img/cachet.png";
import { frenchDateOnly, splitNameStringForPrintingAttestation, numeroPoliceAffichage } from "../../../../variables/functions";
import AntidateBadge from "./AntidateBadge";
import { resolveAttestationDriver } from "./attestationDriver";

const AttestationTPV = React.forwardRef((props, ref) => {
  // Nom imprimé : mono-engin → assuré par défaut ; flotte → conducteur ; interrupteur = preferSouscripteur.
  const d = resolveAttestationDriver({ contrat: props?.contrat, engin: props?.engin, preferSouscripteur: props?.preferSouscripteur });
  const driverNom = d.nom;
  const driverPrenom = d.prenom;
  const driverNomComplet = d.nomComplet;
  const driverAdresse = d.adresse;
  const driverContact = d.contact;
  const driverProfession = d.profession;
  return (
    <div className="container">
      <div
        ref={ref}
        className=""
        style={{
          height: 400,
          width: 1080,
          backgroundImage: `url(${attestationMotoScan})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          position: "absolute",
        }}
      >
        <AntidateBadge contrat={props.contrat} />
        <div className="row">
          <div className="col" style={{ position: "relative" }}>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "20px",
                marginTop: "65px",
                fontSize: "12px",
              }}
            >
              <b>
                {driverNom}{" "}
                {driverPrenom || ""}{" "}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "20px",
                marginTop: "80px",
                fontSize: "12px",
              }}
            >
              <b>{driverContact}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "75px",
                marginTop: "95px",
                fontSize: "12px",
              }}
            >
              <b>
                {numeroPoliceAffichage(props.contrat)}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "37px",
                marginTop: "110px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "125px",
                marginTop: "110px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "115px",
                marginTop: "126px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "112px",
                marginTop: "143px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "78px",
                marginTop: "160px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.numeroChassis?.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "80px",
                marginTop: "176px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.genre || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "15px",
                marginTop: "210px",
                fontSize: "11px",
              }}
            >
              Imprimée à {props.contrat?.producteur?.agence?.typeAgence === "SIEGE" ? "LOME (Siège)" : props.contrat?.producteur?.agence?.ville} le {props?.contrat?.dateImpressionAttestation ? props?.contrat?.dateImpressionAttestation?.split("T")[0] : props?.contrat.createdAt?.split("T")[0]}
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "15px",
                marginTop: "220px",
                fontSize: "11px",
              }}
            >
              par {props.contrat?.producteur?.codeId}
            </h6>
          </div>
          <div className="col">
            <h6
              className=""
              style={{
                position: "absolute",
                marginLeft: "-40px",
                marginTop: "98px",
                fontSize: "12px",
              }}
            >
              <b>
                {numeroPoliceAffichage(props.contrat)}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-81px",
                marginTop: "115px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "7px",
                marginTop: "115px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-3px",
                marginTop: "132px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-4px",
                marginTop: "150px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-39px",
                marginTop: "165px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.numeroChassis?.toUpperCase() || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-50px",
                marginTop: "181px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.genre || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "10px",
                marginTop: "198px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.usage || "_"}</b>
            </h6>

          </div>
          <div className="col">
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-82px",
                marginTop: "20px",
                fontSize: "12px",
              }}
            >
              <b>
                {
                  splitNameStringForPrintingAttestation(
                    `${driverNomComplet}`,
                    21,
                  ).firstLine
                }
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-217px",
                marginTop: "46px",
                fontSize: "12px",
              }}
            >
              <b>
                {
                  splitNameStringForPrintingAttestation(
                    `${driverNomComplet}`,
                    21,
                  ).secondLine
                }{" "}
                {driverAdresse}{" "}
                {driverContact}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-150px",
                marginTop: "64px",
                fontSize: "12px",
              }}
            >
              <b>{driverProfession}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-153px",
                marginTop: "81px",
                fontSize: "12px",
              }}
            >
              <b>
                {numeroPoliceAffichage(props.contrat)}
              </b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-180px",
                marginTop: "107px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEffet)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-65px",
                marginTop: "107px",
                fontSize: "12px",
              }}
            >
              <b>{frenchDateOnly(props.contrat?.dateEcheance)}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-120px",
                marginTop: "128px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-122px",
                marginTop: "145px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-155px",
                marginTop: "162px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.numeroChassis?.toUpperCase() || ""}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-135px",
                marginTop: "180px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.genre || "-"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-55px",
                marginTop: "197px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.usage || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-182px",
                marginTop: "243px",
                fontSize: "12px",
              }}
            >
              <b>App. Terrestre</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-32px",
                marginTop: "243px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.marque || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "-100px",
                marginTop: "257px",
                fontSize: "12px",
              }}
            >
              <b>{props.engin?.immatriculation.toUpperCase() || "_"}</b>
            </h6>
            <h6
              className="text-left"
              style={{
                position: "absolute",
                marginLeft: "105px",
                marginTop: "190px",
              }}
            >
              {props.contrat?.organisme?.typeOrganisme === "POOL" && (
                <img style={{ width: "60%" }} alt="Signature" src={signature} />
              )}
            </h6>

          </div>
        </div>
      </div>
    </div>
  );
});
AttestationTPV.propTypes = {
  contrat: PropTypes.object,
  engin: PropTypes.object,
  printing: PropTypes.bool,
};
AttestationTPV.displayName = "Attestation TPV";

export default AttestationTPV;
